import './DashboardPage.scss';

import { StatsCard } from '@components/index';
import { CommandesDuMois, OrdersListLine, OrdersStatusLine, Ventes, VentesDuMois, ProductsCatalogLine, NewsLine, WarningLine, CustomersListLine } from '@assets/images/icons';
import { Button, Card, Icon, Typography } from '@design-system/index';
import useDashboardPageVM from './useDashboardPageVM';
import { formatMoney, formatNumber, formatPercentage } from '@utils/numbers';
import ReactApexChart from 'react-apexcharts';
import DatePicker, { registerLocale } from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import fr from 'date-fns/locale/fr';
registerLocale('fr', fr);

export default function DashboardPage() {

    const { dashboardDataIsLoading, chartIsLoading, dashboardData, series, options, dashboardChart, startDate, endDate, setStartDate, setEndDate, navigate } = useDashboardPageVM();
   
    return (
        <div className="dashboard-page">

            <div className="dashboard-page-cta">
                <Button
                    variant="outlined"
                    size="large"
                    icon={
                        <Icon variant="surrounded" rounded icon={<ProductsCatalogLine />} size={22} iconInsetSpacing={12} color="sky" />
                    }
                    onClick={() => navigate('/products-management/products/add')}
                >
                    Créer un nouveau produit
                </Button>
                <Button
                    variant="outlined"
                    size="large"
                    icon={
                        <Icon
                            variant="surrounded"
                            rounded
                            icon={<NewsLine />}
                            size={22}
                            iconInsetSpacing={12}
                            color="sky"
                        />
                    }
                    onClick={() => navigate('/products-management/news/add')}
                >
                    Créer une actualité
                </Button>
                <Button
                    variant="outlined"
                    size="large"
                    icon={
                        <Icon
                            variant="surrounded"
                            rounded
                            icon={<WarningLine />}
                            size={22}
                            iconInsetSpacing={12}
                            color="sky"
                        />
                    }
                    onClick={() => navigate('/products-management/flash-infos/add')}
                >
                    Créer une info flash
                </Button>
                <Button
                    variant="outlined"
                    size="large"
                    icon={
                        <Icon
                            variant="surrounded"
                            rounded
                            icon={<CustomersListLine />}
                            size={22}
                            iconInsetSpacing={12}
                            color="sky"
                        />
                    }
                    onClick={() => navigate('/products-management/members-validation')}
                >
                    Gérer les validations adhérents
                </Button>
            </div>

            <div className="dashboard-page-stats-cards">
                <StatsCard 
                    icon={<Ventes />} 
                    title="Ventes" 
                    badge="year" 
                    value={formatMoney(dashboardData?.salesYear.value)} 
                    subValue={formatPercentage(dashboardData?.salesYear.subValue)} 
                    subTitle="Total année en cours" 
                    direction={dashboardData?.salesYear.direction}
                    loading={dashboardDataIsLoading}
                />
                <StatsCard 
                    icon={<VentesDuMois />} 
                    title="Ventes du mois" 
                    badge="month" 
                    value={formatMoney(dashboardData?.salesMonth.value)} 
                    subValue={formatPercentage(dashboardData?.salesMonth.subValue)} 
                    subTitle="Total mois en cours" 
                    direction={dashboardData?.salesMonth.direction}
                    loading={dashboardDataIsLoading}
                />
                <StatsCard 
                    icon={<OrdersListLine />} 
                    title="Commandes" 
                    badge="year" 
                    value={formatNumber(dashboardData?.ordersYear.value)} 
                    subValue={formatPercentage(dashboardData?.ordersYear.subValue)} 
                    subTitle="Total année en cours" 
                    direction={dashboardData?.ordersYear.direction}
                    loading={dashboardDataIsLoading}
                />
                <StatsCard 
                    icon={<CommandesDuMois />} 
                    title="Commandes du mois" 
                    badge="month" 
                    value={formatNumber(dashboardData?.ordersMonth.value)} 
                    subValue={formatPercentage(dashboardData?.ordersMonth.subValue)} 
                    subTitle="Total mois en cours" 
                    direction={dashboardData?.ordersMonth.direction}
                    loading={dashboardDataIsLoading}
                />
            </div>

            <Card headerTitle="Commandes" headerType='full' headerIcon={<Icon icon={<OrdersStatusLine />} size={20} color="secondary" />} headerStaticAction={
                <div className="chart-date-picker">
                    <Typography intrinsic="p" color="secondary">Période :</Typography>
                    <DatePicker
                        selected={startDate}
                        dateFormat="dd/MM/yyyy"
                        onChange={(date) => setStartDate(date ?? new Date())}
                        locale="fr"
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                    />
                    <Typography intrinsic="p" color="secondary">au</Typography>
                    <DatePicker
                        selected={endDate}
                        dateFormat="dd/MM/yyyy"
                        onChange={(date) => setEndDate(date ?? new Date())}
                        locale="fr"
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                    />
                </div>
            }>
                
                <div className="chart-container">
                    <div className="chart">
                        <ReactApexChart options={options} series={series} type="area" height={"350px"} />
                    </div>
                    <div className="chart-stats-card">
                        <StatsCard light value={formatNumber(dashboardChart?.stats.totalSales)} subTitle="Nombre de commandes" loading={chartIsLoading} />
                        <StatsCard light value={formatMoney(dashboardChart?.stats.minimumAmount, '-')} subTitle="Montant minimum" loading={chartIsLoading} />
                        <StatsCard light value={formatMoney(dashboardChart?.stats.maximumAmount, '-')} subTitle="Montant maximum" loading={chartIsLoading} />
                        <StatsCard light value={formatMoney(dashboardChart?.stats.totalAmount)} subTitle="Montant total" loading={chartIsLoading}/>
                    </div>
                </div>
            </Card>
        </div>
    );
};
